var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
export default gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment ORGANIZATION_TPA_FRAGMENT on Organization {\n    id\n    name\n    third_party_admin {\n      id\n      abbr\n      name\n    }\n  }\n"], ["\n  fragment ORGANIZATION_TPA_FRAGMENT on Organization {\n    id\n    name\n    third_party_admin {\n      id\n      abbr\n      name\n    }\n  }\n"])));
var templateObject_1;
